import React, {useEffect, useState} from 'react';
import logo from '../public/assets/images/logo.png';
import {useHistory, useLocation} from "react-router-dom";
import axios from "../axios";

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
}

const Verify = (props) => {
    let query = useQuery();
    let history = useHistory();

    const [verified, setVerified] = useState(true);
    const [showResendCode, setShowResendCode] = useState(false);
    const [message, setMessage] = useState("");

    let path = props.location.pathname;
    let email = query.get('email');
    let verification_code = query.get('code');
    const [name, setName] = useState(email);
    const [error, setError] = useState('');

    console.log("Query Params", email, verification_code)
    console.log("Verified:", verified)

    const handleSubmit = (evt) => {
        evt.preventDefault();
        setError('')
        resendVerificationCode(email)
    }
    function isTutorRequest() {
        if (path === "/pro/code") {
            console.log("Tutor Request")
            return true
        } else {
            console.log("Student Request")
            return false
        }
    }
    function resendVerificationAPI() {
        let verification_api_path = "/resend-verification-email"
        if (isTutorRequest()) {
            verification_api_path = "/tutor" + verification_api_path
        }
        return verification_api_path;
    }
    function checkVerificationAPI() {
        if (isTutorRequest()) {
            return "/tutor/verify-tutor-email";
        } else {
            return "/verify-student-email";
        }
    }
    function resendVerificationCode(email) {
        // TODO change to Post request
        axios.post(resendVerificationAPI(), {
            email: name
        })
            .then(function (res) {
                // handle success
                console.log("Resend Then", res);
                if (res.data._metadata.message === "Email Not Exist.") {
                    setError(res.data._metadata.message)
                } else if (res.data._metadata.message === "Email Already Verified.") {
                    setError(res.data._metadata.message)
                } else {
                    setError('Verification Code Sent!')
                }
            })
            .catch(function (error) {
                // handle error
                setError("Server Error")
                console.log("Resend Error", error);
            })
    }
    useEffect(() => {
        function checkVerificationCode(email, code) {
            axios.post(checkVerificationAPI(), {
                email, code
            })
                .then(function (res) {
                    setMessage(res.data._metadata.message)
                    // handle success
                    console.log("Then", res);
                    if (res.data._metadata.outcomeCode === 200) {
                        redirectToSignin();
                    } else if (res.data._metadata.message === "Email Already Verified.") {
                        setMessage(res.data._metadata.message)
                        redirectToSignin();
                    } else {
                        setVerified(false)
                        setShowResendCode(true)
                    }
                })
                .catch(function (error) {
                    // handle error
                    console.log("Error", error);
                })
        }
        checkVerificationCode(email, verification_code);
    }, []);

    function redirectToSignin() {
        if (isTutorRequest()) {
            history.push('/pro')
        } else {
            history.push('/');
        }
    }
    return (
        <>
            <div className="account-wrap reset-password">
                <div className="logo">
                    <a href="javascript:void(0)" onClick={props.goToLogin}><img src={logo} alt=""/></a>
                </div>
                <div className="container position-relative">
                    <div className="row">
                        <div className="col-sm-7 offset-sm-5">
                            {verified && <div className="account-form-wrap form-signup">
                                <div className="account-title">
                                    <h3><em>Please Wait</em></h3>
                                    <p><em>We are verifying your login code</em></p>
                                </div>
                                <div>
                                    <h3>{message}</h3>
                                </div>
                            </div>}
                            {showResendCode && <div className="account-form-wrap form-signup">
                                <div className="account-title">
                                    <h3><em>Resend Verification Code?</em></h3>
                                    <p><em>We’ll resend code and get back on track.</em></p>
                                </div>
                                <form onSubmit={handleSubmit}>
                                    <div className="form-floating no-icon">
                                        <div className="form-row">
                                            <div className="form-group col-sm-8">
                                                <label>Username or email address*</label>
                                                <input type="text" value={name}
                                                       onChange={e => setName(e.target.value)}
                                                       className="form-control"/>
                                                <label>{error}</label>
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <button type={"submit"} className="btn btn-round btn-secondary">
                                                Resend Code
                                            </button>
                                        </div>
                                        <div className="form-row">
                                            <p>
                                                <em>
                                                    <a href="javascript:void(0);" onClick={redirectToSignin}>Back</a>
                                                </em>
                                            </p>
                                        </div>
                                    </div>
                                </form>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Verify;